module.exports = __webpack_public_path__ + "img/reseau-alpha.ee1697eb.png";